import servicesMixin from './services.js';
import { apiMixin } from 'relapp-api';
import { mapGetters } from 'vuex';

import TechnicalManagementTabs from '../components/TechnicalManagementTabs.vue';

export default {
    components: {
        TechnicalManagementTabs
    },
    mixins: [servicesMixin, apiMixin],
    props: {
        domain: {
            type: String,
            default: null
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: null
        };
    },
    computed: {
        ...mapGetters({
            getFirstServiceForDomain: 'services/firstServiceForDomain',
            getServiceForDomain: 'services/serviceForDomain',
            getServicesByDomain: 'services/servicesByDomain',
            getServicesForDomain: 'services/multipleServiceForDomain'
        }),
        /**
         * Get the domain service.
         *
         * @return {object}
         */
        service() {
            if (!this.serviceType || !this.domain) {
                return null;
            }

            return this.getServiceForDomain({
                domain: this.domain,
                type: this.serviceType
            });
        },
        /**
         * Get the first service for a domain.
         *
         * @return {object}
         */
        firstServiceForDomain() {
            if (!this.serviceType || !this.domain) {
                return null;
            }

            return this.getFirstServiceForDomain({
                domain: this.domain
            });
        },
        /**
         * Get the domain service.
         *
         * @return {array}
         */
        services() {
            if (!this.serviceType || !this.domain) {
                return null;
            }

            return this.getServicesForDomain({
                domain: this.domain,
                type: this.serviceType
            });
        },
        /**
         * Get the services by the current domain.
         *
         * @todo DEHAPP-244: show also the dns subscription
         *
         * @return {array}
         */
        servicesByDomain() {
            return this.getServicesByDomain[this.domain].filter(service =>
                ['extension', 'hosting', 'ssl', 'vps'].includes(service.type)
            );
        }
    }
};
